import React from 'react';

export function TypingIndicator() {
  return (
    <div className="typing-dots" aria-label="Nova is typing">
      <span className="typing-dot"></span>
      <span className="typing-dot"></span>
      <span className="typing-dot"></span>
    </div>
  );
}
